import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { RmaTicketCountQuery, RmaTicketCountQueryVariables } from '@/shared/api';
import RMA_TICKET_COUNT_QUERY from '../queries/rmaTicketCount';

/**
 * Counts the RMA tickets matching a filter so the RMA tab badge can be rendered. Queries RMA_TICKET_COUNT_QUERY with the filter and unwraps the RmaTicketCount field through the shared error handler.
 *
 * @param filter - Filter criteria for the RMA tickets to count.
 * @returns Promise resolving to the RMA ticket count.
 */
const fetchRmaTicketCount = async (
  filter: RmaTicketCountQueryVariables['filter'],
): Promise<RmaTicketCountQuery['RmaTicketCount']> => {
  const client = createClient();
  const result = await client.query<RmaTicketCountQuery, RmaTicketCountQueryVariables>({
    query: RMA_TICKET_COUNT_QUERY,
    variables: {
      filter,
    },
  });
  return handleErrorApi(result, 'RmaTicketCount');
};

export default fetchRmaTicketCount;
